const { styled,  Paper } = require("@mui/material");

export const HoverStyledCard = styled(Paper)(() => (
    {
        transition: "transform 500ms",

        marginRight: "5px", flexShrink: 0,
        ":hover": {
            transform: "scale(1.05)",
            cursor: "default"
        },
        
        })
    
)